import qs from 'qs'
import type { LocalizedPlaceResult } from 'hooks/usePlace'
import type { TrendingDestination } from './constants'

export const buildHotelUrl = (destinationName: string, destinationId: string, holidayType?: string) => {
  const hotelParams = {
    destinationName,
    destinationId,
    adults: 2,
    children: 'none',
    flexibleWithDate: true,
    holidayTypes: holidayType,

  }
  return `/search?${qs.stringify(hotelParams)}`
}

export function resolveTrendingDestinationTiles<T extends { placeId: string; imageId?: string; image?: App.Image }>(
  items: ReadonlyArray<T>,
  localizedPlaces: Record<string, LocalizedPlaceResult>,
  getUrl: (item: T, resolvedName?: string) => string | undefined,
): Array<TrendingDestination> {
  const resolved: Array<TrendingDestination> = []

  for (const item of items) {
    if (!item.imageId) continue

    const localized = localizedPlaces[item.placeId]

    if (localized?.isLoading ?? true) {
      resolved.push({
        destinationId: item.placeId,
        imageId: item.imageId,
        image: item.image,
        url: getUrl(item) ?? '',
        isLoading: true,
      })
      continue
    }

    if (localized.isUnavailable || !localized.place?.name) {
      continue
    }

    const url = getUrl(item, localized.place.name)
    if (!url) continue

    resolved.push({
      name: localized.place.name,
      destinationId: item.placeId,
      imageId: item.imageId,
      image: item.image,
      url,
    })
  }

  return resolved
}
